/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { user } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const USER_CHANGE_TIER_LEVEL = 'user.changeTierLevel';
export const USER_LOGOUT = 'user.logout';

queryClient.setMutationDefaults(USER_CHANGE_TIER_LEVEL, {
  mutationFn: user.requestChangeTierLevel,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(USER_LOGOUT, {
  mutationFn: user.logout,
  onError: (error) => {
    handleError(error);
  },
});
